import React from "react";

const Field = ({ label, value, mono }) => (
    <div className="py-2 border-b hairline last:border-b-0">
        <p className="mono-label">{label}</p>
        <p
            className={`mt-1 ${mono ? "mono-data" : ""}`}
            style={{
                fontSize: mono ? 13 : 14.5,
                color: "var(--ink)",
                fontFamily: mono
                    ? "JetBrains Mono, monospace"
                    : "IBM Plex Sans, sans-serif",
            }}
        >
            {value}
        </p>
    </div>
);

export const ConsentRequest = ({ request }) => {
    if (!request) return null;
    return (
        <section className="panel" data-testid="consent-request">
            <div className="px-6 sm:px-8 py-5 border-b hairline">
                <p className="mono-label">Step 03 · Purpose-bound request</p>
                <h2
                    className="font-serif mt-1"
                    style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                >
                    {request.summary}
                </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="px-6 sm:px-8 py-5 md:border-r hairline">
                    <Field label="Requested by" value={request.requested_by} mono />
                    <Field label="Purpose" value={request.purpose} mono />
                    <Field label="Duration" value={request.duration} />
                </div>
                <div className="px-6 sm:px-8 py-5">
                    <Field
                        label="Allowed roles"
                        value={(request.allowed_roles || []).join("  ·  ")}
                        mono
                    />
                    <Field
                        label="Consent receipt ref"
                        value={request.consent_receipt_ref}
                        mono
                    />
                </div>
            </div>
        </section>
    );
};

export default ConsentRequest;
